if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const variantInputs = document.querySelectorAll('.product-variant-size-container .variant-input');
        if (variantInputs.length > 0) {
          const anyChecked = Array.from(variantInputs).some((input) => input.checked);
          const availableVariantsCount = Array.from(variantInputs).filter((input) => !input.classList.contains('disabled')).length;

          if (availableVariantsCount > 1 && !anyChecked) {
            const containerVariantPDP = document.querySelector('.product-variant-size-container');
            if (containerVariantPDP) {
              containerVariantPDP.classList.add('select-size');
              const getPositionVariantPDP = containerVariantPDP.getBoundingClientRect();
              const positionVariantPDP = getPositionVariantPDP.top + window.scrollY - 200;
              window.scroll({
                top: positionVariantPDP,
                behavior: 'smooth',
              });
            }
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // GTM add_to_cart_standard push — disabled 2026-08: tracking migrated
            // to the official Google & YouTube app (web pixel).
            /*
            try {
              var addedVariantId = response.id || response.variant_id;
              var addedQuantity = response.quantity || 1;
              var addedPrice = typeof response.price === "number"
                ? response.price / 100
                : parseFloat(response.price) || 0;
              var addedTitle = response.product_title || response.title || "";
              var shopCurrency =
                (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "add_to_cart_standard",
                product_id: addedVariantId,
                product_name: addedTitle,
                product_price: addedPrice,
                product_quantity: addedQuantity,
                currency: shopCurrency,
                value: addedPrice * addedQuantity,
              });
            } catch (e) {
              console.warn("add_to_cart_standard push failed", e);
            }
            */

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            var trueFound = false;
            var falseFound = false;
            var cartItems = document.querySelectorAll(".cart-item");

            cartItems.forEach(function (item) {
              var teamStoreValue = item.getAttribute("data-team-store-drawer");
              if (teamStoreValue === "true") {
                trueFound = true;
              } else if (teamStoreValue === "false") {
                falseFound = true;
              }
            });

            if (trueFound && falseFound) {
              var button = document.getElementById("CartDrawer-Checkout");
              button.setAttribute("disabled", "disabled");
              var popup = document.getElementById("drawer-popup");
              popup.style.display = "block";
            }
            new Swiper('#product-slider-cart-drawer', {
              navigation: {
                nextEl: '.section-recommend-swiper-button-next',
                prevEl: '.section-recommend-swiper-button-prev',
              },
              slidesPerView: 2,
              spaceBetween: 4,
              breakpoints: {
                551: {
                    slidesPerView: 2,
                    spaceBetween: 4,
                },
                750: {
                  slidesPerView: 2,
                  spaceBetween: 4,
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 4,
                }
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");

            if (typeof window.getMostExpensiveProductId === "function") {
              const mostExpensiveId = window.getMostExpensiveProductId();
              if (typeof mostExpensiveId === "string") {
              }
            }

            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
